module.exports = __webpack_public_path__ + "img/GALLERY-BALENO-4.895d76ce.jpg";